import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { TIERS, TIER_LABELS } from "../../utils/common/productRoles";

/*
 * Product-scoped role picker for the /products deploy modals — unlike
 * ProductRoleAssigner/CombinedRoleAssigner (which manage roles across every
 * product), this only ever shows/manages the current product's own 4 tiers
 * (User/Contributor/Reviewer/Admin), since the product context is already
 * implicit from the page you're on. Purely a selection UI, same as the other
 * two role pickers: the caller owns the pending tier list via
 * `value`/`onAdd`/`onRemove` and applies it (grant/revoke) on Save.
 */
const ProductScopedRoleAssigner = ({ value, onAdd, onRemove }) => {
  const [selectedTier, setSelectedTier] = useState("");

  const handleAdd = () => {
    if (!selectedTier) {
      return;
    }
    if (!value.includes(selectedTier)) {
      onAdd(selectedTier);
    }
    setSelectedTier("");
  };

  return (
    <div className="product-scoped-role-assigner">
      <Row className="align-items-center">
        <Col>
          <Form.Select
            aria-label="User Role"
            className="rounded-0"
            value={selectedTier}
            onChange={(e) => setSelectedTier(e.target.value)}
          >
            <option value="">User Role</option>
            {TIERS.map((tier) => (
              <option value={tier} key={tier}>
                {TIER_LABELS[tier]}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col xs="auto">
          <button
            type="button"
            className="btn-transparent modal-add-btn"
            onClick={handleAdd}
            disabled={!selectedTier}
          >
            Add
          </button>
        </Col>
      </Row>
      {value.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mt-2">
          {value.map((tier) => (
            <span key={tier} className="modal-chip">
              {TIER_LABELS[tier]}
              <button
                type="button"
                className="modal-chip-remove"
                onClick={() => onRemove(tier)}
                aria-label={`Remove ${TIER_LABELS[tier]}`}
              >
                &times;
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductScopedRoleAssigner;
